import React from "react"
import PropTypes from "prop-types"
import styled, {ThemeProvider} from 'styled-components'
import {GlobalStyle, theme} from '../../themes/theme'

import Header from "../header/Header"
import HeaderMobile from '../header-mobile/HeaderMobile'
import Footer from "../footer/Footer"
import Cookies from "../cookies/Cookies";

const Layout = ({children, path}) => {

    if (typeof window !== "undefined") {
        // eslint-disable-next-line global-require
        require("smooth-scroll")('a[href*="#"]')
    }

    return (
        <>
            <GlobalStyle />
            <ThemeProvider theme={theme}>
                <Header path={path}/>
                <HeaderMobile path={path}/>
                <Main>
                    {children}
                </Main>
                <Footer path={path}/>
                <Cookies />
            </ThemeProvider>
        </>
    )
}

Layout.propTypes = {
    children: PropTypes.node.isRequired,
}

const Main = styled.div`
`

// const A = styled.a`
//   color: #3B869D;
//   font-family: Sequel45;
//   font-size: 1.2rem;
//   font-weight: 400;
//   line-height: 1.6rem;
// `

export default Layout
